import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  pageTitleContainer: {
    marginBottom: theme.spacing(1),
  },
}))
